import { render, staticRenderFns } from "./IconSlider.vue?vue&type=template&id=7a099239&scoped=true&"
import script from "./IconSlider.vue?vue&type=script&lang=js&"
export * from "./IconSlider.vue?vue&type=script&lang=js&"
import style0 from "./IconSlider.vue?vue&type=style&index=0&id=7a099239&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a099239",
  null
  
)

export default component.exports